import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { TrimSpacesDirective } from '@directives/trim-spaces.directive';
import { EditorComponentBase, IconSanitizerService } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-multi-input-editor',
    templateUrl: './multi-input-editor.component.html',
    styleUrls: ['./multi-input-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, ValidationErrorMessageComponent, TrimSpacesDirective]
})
export class MultiInputEditorComponent extends EditorComponentBase<string[]> implements OnInit {
    errorIndexes: Record<number, string> = {};

    removeFieldIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        super();
        this.removeFieldIcon = this.iconSanitizer.getIcon('removeField');
    }

    ngOnInit(): void {
        if (!this.isReadOnly && !this.bindingProperty?.length) this.addNewField();
    }

    dataChanged(): void {
        this.bindingProperty = this.bindingProperty?.map((value) => value.trim()) || [];

        this.validate();
        this.extractErrorIndexes();
    }

    addNewField(): void {
        this.bindingProperty?.push('');
        this.dataChanged();
    }

    removeField(index: number): void {
        this.bindingProperty?.splice(index, 1);
        this.dataChanged();
    }

    trackByFn(index: number): number {
        return index;
    }

    private extractErrorIndexes(): void {
        this.errorIndexes = {};
        this.validationErrors?.forEach((validationError) => {
            validationError?.errors?.forEach((error) => {
                this.errorIndexes[error.index] = error.message;
            });
        });
    }
}
